import { useCallback } from "react";
import ConfigurationTargetBoxDetails from "./ConfigurationTargetBoxDetails";
import { MVisionAppClient } from '../../store/configurationTarget/mvision-client-list';
import { useDispatch, useSelector } from "react-redux";
import { allModelCustomizationsReset, modelCustomizationExported, modelCustomizationImported, modelCustomizationImportFailed, modelCustomizationPdfExportRequested, resetCustomizationImportExportError } from "../../store/contouring/contouringSlice";
import { StoreState } from "../../store/store";
import { readModelCustomizationJsonFile } from "../../store/contouring/contouring-helpers";
import { ModelType } from "../../store/global-types/customization-types";


const ConfigurationTargetBoxDetailsContour = () => {

    const dispatch = useDispatch();

    const isResetInProgress = useSelector((state: StoreState) => state.contouring.isAllModelCustomizationsResetInProgress);
    const resetErrorMessage = useSelector((state: StoreState) => state.contouring.allModelCustomizationsResetError);
    const importExportErrorMessage = useSelector((state: StoreState) => state.contouring.customizationImportExportError);
    const pdfExportInProgress = useSelector((state: StoreState) => state.contouring.pdfExportInProgress);

    const handleResetAllModelCustomizations = useCallback((configurationTarget: MVisionAppClient) => {
        dispatch(allModelCustomizationsReset(configurationTarget));
    }, [dispatch]);

    const handleExportModelCustomization = useCallback((configurationTarget: MVisionAppClient) => {
        dispatch(modelCustomizationExported(configurationTarget));
    }, [dispatch]);

    const handleExportPdf = useCallback((configurationTarget: MVisionAppClient) => {
        dispatch(modelCustomizationPdfExportRequested(configurationTarget));
    }, [dispatch]);

    const handleImportUserData = useCallback(async (jsonFile: File) => {
        // Clear previous error
        dispatch(resetCustomizationImportExportError());
        
        try {
            const readFile = await readModelCustomizationJsonFile(jsonFile);
            dispatch(modelCustomizationImported(readFile));
            return true;
        } catch (error) {
            console.log(error);
            dispatch(modelCustomizationImportFailed('Error importing Contour+ configuration. Please ensure the imported data is valid.'));
            return false;
        }
    }, [dispatch]);


    return (
        <ConfigurationTargetBoxDetails
            modelType={ModelType.Contouring}
            isResetInProgress={isResetInProgress}
            resetErrorMessage={resetErrorMessage}
            onResetAllModelCustomizations={handleResetAllModelCustomizations}
            onExportModelCustomization={handleExportModelCustomization}
            onExportPdf={handleExportPdf}
            pdfExportInProgress={pdfExportInProgress}
            onImportUserData={handleImportUserData}
            importExportErrorMessage={importExportErrorMessage}

        />
    );
}

export default ConfigurationTargetBoxDetailsContour;
